import { arrayRemoveDuplicates } from '../../../../platform/core/array-extensions';

export class HtmlFormattingOptions {
	private whitelistedTags: Set<string>;

	public constructor(tags: string) {
		this.whitelistedTags = new Set(tags.split(/\s+/).map((tag) => this.normaliseTagName(tag)));
	}

	public allows(tagName: string): boolean {
		const tagNameNormalized = this.normaliseTagName(tagName);
		if (tagNameNormalized === this.normaliseTagName('p')) {
			return true;
		}

		const compatibleTags = this.determineCompatibleTags(tagNameNormalized);
		return !!compatibleTags.find((tag) => this.whitelistedTags.has(tag));
	}

	public convertToTinyMceToolbar(): string {
		const tinyMceOptions = [...this.whitelistedTags.values()].map((tag) => this.determineTinyMceOption(tag));
		return arrayRemoveDuplicates(tinyMceOptions).join(' ');
	}

	private determineTinyMceOption(tagNameNormalised: string): string {
		switch (tagNameNormalised) {
			case 'b':
			case 'strong':
				return 'bold';
			case 'ul':
				return 'bullist';
			default:
				return tagNameNormalised;
		}
	}

	private determineCompatibleTags(tagNameNormalised: string): readonly string[] {
		const compatibilityLists = [
			['b', 'strong'],
			['i', 'em'],
			['del', 'strike'],
			['li', 'ol'],
			['li', 'ul'],
		];

		const applicableCompatibilityLists = compatibilityLists.filter((list) => list.includes(tagNameNormalised));
		const allCompatibleTags = arrayRemoveDuplicates(applicableCompatibilityLists.flat());

		return allCompatibleTags.length === 0 ? [tagNameNormalised] : allCompatibleTags;
	}

	private normaliseTagName(tagName: string): string {
		return tagName.toLowerCase();
	}
}
